/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import backbone from 'backbone';
import dialogTemplate from '@bingads-webui-static-legacy/uet/template/dialog.pug';
import tagViewerContent from '@bingads-webui-static-legacy/uet/template/tagViewerContent.pug';
import tagViewerFooter from '@bingads-webui-static-legacy/uet/template/tagViewerFooter.pug';
import download from '@bingads-webui-component-legacy/download/index';
import * as url from '@bingads-webui/url-util';
import instrumentationSettings from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import pageContext from '@bingads-webui-static-legacy/page-context';
import '@bingads-webui-static-legacy/instrumentation/instrumentation';
import 'bootstrap';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
var view = backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    this.renderThirdPartyIntegrationView = this.options.renderThirdPartyIntegrationView;
  },
  events: {
    'click .btn-uet-email-tag': 'emailTag',
    'click .btn-uet-copy-tag': 'copyTag',
    'click .btn-uet-download-tag': 'downloadTag',
    'click .btn-uet-gtm-tag': 'startGTMIntegrationFlow',
    'hidden.bs.modal': 'onClose'
  },
  render: (function () {
    var tag = Object.assign({}, this.options.tag);
    const isUetAutoSpaTrackingEnabled = _.result(pageContext.Permissions.dynamic, 'UetAutoSpaTracking');
    var scriptMatches = (/<script>(.*?)<\/script>/).exec(tag.script);
    if (scriptMatches) {
      tag.script = scriptMatches[0];
    }
    if (isUetAutoSpaTrackingEnabled) {
      tag.script = `<script>(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"${tag.id}", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");</script>`;
    }
    var isGTMIntegrationEnabled = pageContext.Permissions.IsGTMTagIntegrationForUETGridEnabled && !!this.renderThirdPartyIntegrationView;
    var dialog = dialogTemplate({
      title: i18n.getString('UnifiedEventTracking_TagViewer_Title'),
      content: tagViewerContent({
        _,
        i18n: i18n,
        tag: tag
      }),
      footer: tagViewerFooter({
        i18n: i18n,
        isGTMIntegrationEnabled
      }),
      i18n: i18n,
      dialogClass: 'uet tag-viewer'
    });
    this.setElement(dialog);
    this.$el.modal('show');
    if ($.support.transition) {
      this.$el.on($.support.transition.end, function (event) {
        $('.btn-primary', this).focus();
      });
    }
    return this;
  }).asLoggingStart(instrumentationSettings.ACTIVITYNAME.OpenUetTrackingCodePopup, instrumentationSettings.SCENARIONAME.ViewUetTrackingCodePopup),
  hide: function () {
    this.$el.modal('hide');
  },
  copyTag: (function () {
    window.prompt(i18n.getString('UnifiedEventTracking_TagViewer_CopyPrompt'), this.$('.tab-pane.active').val());
  }).asLoggingStart(instrumentationSettings.ACTIVITYNAME.CopyTrackingCode, instrumentationSettings.SCENARIONAME.ViewUetTrackingCodePopup),
  emailTag: (function () {
    var subject = encodeURIComponent(i18n.getString('UnifiedEventTracking_TagViewer_EmailSubject') + this.$('.tag-name').text());
    window.location.href = url.mailto('', subject, encodeURIComponent(this.getEmailDownloadBody()));
  }).asLoggingStart(instrumentationSettings.ACTIVITYNAME.EmailTrackingCode, instrumentationSettings.SCENARIONAME.ViewUetTrackingCodePopup),
  downloadTag: (function () {
    download.downloadify(this.$('.tag-name').text() + '.txt', this.getEmailDownloadBody(), 'text/plain');
  }).asLoggingStart(instrumentationSettings.ACTIVITYNAME.DownloadTrackingCode, instrumentationSettings.SCENARIONAME.ViewUetTrackingCodePopup),
  startGTMIntegrationFlow: (function () {
    this.hide();
    this.renderThirdPartyIntegrationView(this.options.tag);
  }).asLoggingStart(instrumentationSettings.ACTIVITYNAME.IntegrateTrackingCodeWithGTM, instrumentationSettings.SCENARIONAME.ViewUetTrackingCodePopup),
  onClose: function () {
    this.remove();
  },
  getEmailDownloadBody: function () {
    return i18n.getString('UnifiedEventTracking_TagViewer_EmailHeader') + '\r\n\r\n' + i18n.getString('UnifiedEventTracking_TagViewer_EmailHelp') + '\r\n\r\n' + this.$('.tab-pane.active').val();
  }
});
export default view;

